<div class="content-block head-div">
  <div class="cb-header">
    <div class="profile-container d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div class="buscador filtro-nombre" style="max-width: 450px; margin-right: 20px;">
          <label class="sr-only" for="searchInput">Buscar por nombre o correo</label>
          <div class="input-group">
            <input 
              type="text" 
              id="searchInput" 
              class="form-control" 
              placeholder="Buscar por nombre" 
              [(ngModel)]="searchQuery" 
              (input)="buscarEstudiantes()"
              [disabled]="isSearching">
            <!-- 🚀 NUEVO: Indicador de búsqueda para Safari -->
            <div class="input-group-append" *ngIf="isSearching">
              <span class="input-group-text">
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="width: 1rem; height: 1rem;"></div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary px-3 py-2" (click)="openOptimizedStudentModal(optimizedStudentModal)">
        <i class="material-icons align-middle me-1" style="font-size: 16px;">person_add</i>
        Registrar Estudiante
      </button>
    </div>
  </div>
  <div class="table-template" style="margin-top: 15px;">
    <table class="table table-lg table-hover row-border hover">
      <thead class="thead-dark text-center">
        <tr>
          <th style="width: 20%;">Nombre</th>
          <th style="width: 20%;">Correo electrónico</th>
          <th style="width: 15%;">Activo</th>
          <th style="width: 15%;">Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="estudiantes.length === 0">
          <td colspan="4" class="text-center">
            <span>No hay estudiantes disponibles.</span>
          </td>
        </tr>
        <tr *ngFor="let estudiante of estudiantes; let i = index" style="text-align: center;">
          <td>{{ estudiante.name }}</td>
          <td>{{ estudiante.email }}</td>
          <td>{{ estudiante.active ? 'Sí' : 'No' }}</td>
          <td class="actions-cell">
            <span 
              class="material-icons text-danger" 
              *ngIf="!estudiante.active" 
              (click)="cambiarEstadoEstudiante(estudiante.id, true)" 
              style="cursor: pointer;"
              title="Habilitar">
              toggle_on
            </span>
            <span 
              class="material-icons text-success" 
              *ngIf="estudiante.active" 
              (click)="cambiarEstadoEstudiante(estudiante.id, false)" 
              style="cursor: pointer;"
              title="Deshabilitar">
              toggle_off
            </span>
            <span 
              class="material-icons icono" 
              (click)="abrirModalVideoteca(assignVideotecaTemplate, estudiante.student_id)" 
              style="cursor: pointer;" 
              title="Asignar videotecas">
              video_library
            </span>
          </td>                       
        </tr>
      </tbody>
    </table>
    <!-- Controles de paginación -->
    <div class="pagination-controls text-center" *ngIf="totalEstudiantes > limit2">
      <button class="btn btn-primary" (click)="cambiarPagina2(currentPage2 - 1)" [disabled]="currentPage2 === 1">
        <span class="material-icons">chevron_left</span>
      </button>
      <span class="page-number">{{ currentPage2 }}</span>
      <button class="btn btn-primary" (click)="cambiarPagina2(currentPage2 + 1)" 
              [disabled]="currentPage2 * limit2 >= totalEstudiantes">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>
  </div>
</div>


<!-- Formulario de estudiantes eliminado -->

<!-- Plantilla para asignar videotecas -->
<ng-template #assignVideotecaTemplate>
  <div class="modal-header">
    <h5 class="modal-title">Asignar Videoteca a Estudiante</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cerrarModal()"></button>
  </div>
  <div class="modal-body">
    <table class="table">
      <thead>
        <tr>
          <th class="text-center">Videoteca</th>
          <th class="text-center">Estado</th>
          <th class="text-center">Rango Expiración (días)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="videotecas.length === 0">
          <td colspan="3" class="text-center">No hay videotecas disponibles</td>
        </tr>
        <tr *ngFor="let videoteca of videotecas; let i = index">
          <td class="text-center">{{ videoteca.name }}</td>
          <td class="text-center">
            <!-- Activate button -->
            <span 
              class="material-icons text-success" 
              *ngIf="videoteca.active" 
              (click)="cambiarEstadoVideoteca(videoteca, false)" 
              [class.disabled]="!videoteca.expirationDays || videoteca.expirationDays <= 0"
              style="cursor: pointer;"
              title="Desactivar">
              toggle_on
            </span>
            <!-- Deactivate button -->
            <span 
              class="material-icons text-danger" 
              *ngIf="!videoteca.active" 
              (click)="cambiarEstadoVideoteca(videoteca, true)" 
              style="cursor: pointer;"
              title="Activar">
              toggle_off
            </span>
          </td>
          <td class="text-center">
            <input
              type="number"
              class="form-control"
              [(ngModel)]="videoteca.expirationDays"
              [ngModelOptions]="{ standalone: true }"
              name="expirationDays{{ i }}"
              placeholder="Días"
              min="1"
              [disabled]="videoteca.active"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-end">
      <button type="button" class="btn btn-secondary me-2" (click)="cerrarModal()">Cerrar</button>
    </div>
  </div>
</ng-template>

<!-- Nuevo Modal Optimizado para Registrar Estudiante -->
<ng-template #optimizedStudentModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Registrar Nuevo Estudiante</h4>
    <button 
      type="button" 
      class="btn-close" 
      aria-label="Close" 
      (click)="cerrarModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <form [formGroup]="optimizedStudentForm" (ngSubmit)="onSubmitOptimizedStudent()">
    <div class="modal-body">
      
      <!-- Campo Nombre -->
      <div class="mb-3">
        <label for="firstName" class="form-label">
          Nombre <span class="text-danger">*</span>
        </label>
        <input 
          type="text" 
          class="form-control"
          id="firstName"
          formControlName="firstName"
          placeholder="Ingrese el nombre"
          [class.is-invalid]="isFieldInvalid('firstName')"
          (blur)="onFieldBlur('firstName')">
        
        <div *ngIf="isFieldInvalid('firstName')" class="invalid-feedback">
          <div *ngIf="optimizedStudentForm.get('firstName')?.errors?.['required']">El nombre es obligatorio.</div>
          <div *ngIf="optimizedStudentForm.get('firstName')?.errors?.['minlength']">El nombre debe tener al menos 2 caracteres.</div>
          <div *ngIf="optimizedStudentForm.get('firstName')?.errors?.['maxlength']">El nombre no puede exceder 50 caracteres.</div>
        </div>
      </div>

      <!-- Campo Apellido -->
      <div class="mb-3">
        <label for="lastName" class="form-label">
          Apellido <span class="text-danger">*</span>
        </label>
        <input 
          type="text" 
          class="form-control"
          id="lastName"
          formControlName="lastName"
          placeholder="Ingrese el apellido"
          [class.is-invalid]="isFieldInvalid('lastName')"
          (blur)="onFieldBlur('lastName')">
        
        <div *ngIf="isFieldInvalid('lastName')" class="invalid-feedback">
          <div *ngIf="optimizedStudentForm.get('lastName')?.errors?.['required']">El apellido es obligatorio.</div>
          <div *ngIf="optimizedStudentForm.get('lastName')?.errors?.['minlength']">El apellido debe tener al menos 2 caracteres.</div>
          <div *ngIf="optimizedStudentForm.get('lastName')?.errors?.['maxlength']">El apellido no puede exceder 50 caracteres.</div>
        </div>
      </div>

      <!-- Campo Email -->
      <div class="mb-3">
        <label for="emailField" class="form-label">
          Correo electrónico <span class="text-danger">*</span>
        </label>
        <input 
          type="email" 
          class="form-control"
          id="emailField"
          formControlName="email"
          placeholder="estudiante@ejemplo.com"
          [class.is-invalid]="isFieldInvalid('email')"
          (blur)="onFieldBlur('email')">
        
        <div *ngIf="isFieldInvalid('email')" class="invalid-feedback">
          <div *ngIf="optimizedStudentForm.get('email')?.errors?.['required']">El correo electrónico es obligatorio.</div>
          <div *ngIf="optimizedStudentForm.get('email')?.errors?.['email']">Ingrese un correo electrónico válido.</div>
        </div>
      </div>

      <!-- Campo Teléfono -->
      <div class="mb-3">
        <label for="phoneField" class="form-label">
          Número de teléfono <span class="text-danger">*</span>
        </label>
        <input 
          type="tel" 
          class="form-control"
          id="phoneField"
          formControlName="phoneNumber"
          placeholder="1234567890"
          maxlength="10"
          [class.is-invalid]="isFieldInvalid('phoneNumber')"
          (blur)="onFieldBlur('phoneNumber')">
        
        <div *ngIf="isFieldInvalid('phoneNumber')" class="invalid-feedback">
          <div *ngIf="optimizedStudentForm.get('phoneNumber')?.errors?.['required']">El número de teléfono es obligatorio.</div>
          <div *ngIf="optimizedStudentForm.get('phoneNumber')?.errors?.['pattern']">Ingrese un número de teléfono válido de 10 dígitos.</div>
        </div>
        <div class="form-text">
          Ingrese 10 dígitos sin espacios ni guiones.
        </div>
      </div>

      <!-- Sección de Videotecas del Instructor -->
      <div class="mb-4">
        <h6 class="mb-3">
          <i class="fas fa-video me-2"></i>
          Asignar Videotecas
        </h6>
        
        <!-- Indicador de carga -->
        <div *ngIf="isLoadingVideotecas" class="text-center py-3">
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          <span>Cargando videotecas...</span>
        </div>
        
        <!-- Lista de videotecas disponibles -->
        <div *ngIf="!isLoadingVideotecas && availableVideotecas.length > 0" class="border rounded p-3">
          <div class="form-check mb-2">
            <input 
              class="form-check-input" 
              type="checkbox" 
              id="selectAllVideotecas"
              [checked]="selectedVideotecas.size === availableVideotecas.length"
              [indeterminate]="selectedVideotecas.size > 0 && selectedVideotecas.size < availableVideotecas.length"
              (change)="toggleAllVideotecas($event)">
            <label class="form-check-label fw-bold" for="selectAllVideotecas">
              Seleccionar todas las videotecas
            </label>
          </div>
          
          <hr class="my-2">
          
          <div class="row">
            <div class="col-md-6" *ngFor="let videoteca of availableVideotecas">
              <div class="form-check mb-2">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  [id]="'videoteca-' + videoteca.id"
                  [value]="videoteca.id"
                  [checked]="selectedVideotecas.has(videoteca.id)"
                  (change)="toggleVideoteca(videoteca.id, $event)">
                <label class="form-check-label" [for]="'videoteca-' + videoteca.id">
                  <i class="fas fa-folder me-1"></i>
                  {{ videoteca.name }}
                </label>
              </div>
            </div>
          </div>
          
          <div class="form-text mt-2">
            <i class="fas fa-info-circle me-1"></i>
            Seleccione las videotecas a las que el estudiante tendrá acceso.
          </div>
        </div>
        
        <!-- Mensaje cuando no hay videotecas -->
        <div *ngIf="!isLoadingVideotecas && availableVideotecas.length === 0" class="alert alert-warning">
          <i class="fas fa-exclamation-triangle me-2"></i>
          No tienes videotecas disponibles para asignar.
        </div>
      </div>
      
    </div>
    
    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-secondary px-3 py-2" 
        (click)="cerrarModal()"
        [disabled]="isOptimizedSubmitting">
        Cancelar
      </button>
      <button 
        type="submit" 
        class="btn btn-primary px-4 py-2"
        [disabled]="optimizedStudentForm.invalid || isOptimizedSubmitting">
        <span *ngIf="isOptimizedSubmitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ isOptimizedSubmitting ? 'Registrando...' : 'Registrar Estudiante' }}
      </button>
    </div>
  </form>
</ng-template>